import { templateJoin } from "bernie-graphql";

export const blossomCustomerNotificationQuery = templateJoin`
        query BlossomCustomerNotification(
  $context: ContextInput!
  $notificationLocation: NotificationLocation!
  $lineOfBusiness: ExpLineOfBusiness!
  $funnelLocation: FunnelLocation!
) {
  customer(context: $context) {
    notification (
      notificationLocation: $notificationLocation,
      lineOfBusiness: $lineOfBusiness,
      funnelLocation: $funnelLocation
    ) {
      type
      title {
        items {
          __typename
          text
          styles
          ... on CustomerNotificationPhraseLinkNode {
            url
            target
            actions {
              __typename
              ... on CustomerNotificationAnalytics {
                description
                referrerId
              }
              ... on CustomerNotificationCookie {
                name
                value
                expires
              }
            }
          }
        }
      }
      body {
        items {
          __typename
          text
          styles
          ... on CustomerNotificationPhraseLinkNode {
            url
            target
            actions {
              __typename
              ... on CustomerNotificationAnalytics {
                description
                referrerId
              }
              ... on CustomerNotificationCookie {
                name
                value
                expires
              }
            }
          }
        }
      }
      containerLink {
        url
        target
        actions {
          __typename
          ... on CustomerNotificationAnalytics {
            description
            referrerId
          }
          ... on CustomerNotificationCookie {
            name
            value
            expires
          }
        }
      }
      logo {
        description
        url
      }
      links {
        id
        text
        url
        icon {
          id
          description
        }
        actions {
          __typename
          ... on CustomerNotificationAnalytics {
            description
            referrerId
          }
          ... on CustomerNotificationCookie {
            name
            value
            expires
          }
        }
      }
      dismiss {
        icon {
          id
          description
        }
        actions {
          __typename
          ... on CustomerNotificationAnalytics {
            description
            referrerId
          }
          ... on CustomerNotificationCookie {
            name
            value
            expires
          }
        }
      }
      revealActions {
        __typename
        ... on CustomerNotificationAnalytics {
          description
          referrerId
        }
        ... on CustomerNotificationCookie {
          name
          value
          expires
        }
      }
      backgroundId
      backgroundImage { url }
    }
  }
}
    `;

export const campaignByIdQueryQuery = templateJoin`
        query CampaignByIdQuery(
  $productType: [CampaignProductType!]
  $context: ContextInput!
  $userLocation: UserLocationInput
  $referrer: String
  $enableTripAttach: Boolean
  $displayPropertyCount: Boolean
  $campaignId: String!
  $pageSize: Int
  $pageNumber: Int!


) {
  campaignRecommendations(
    productType: $productType
    userLocation: $userLocation
    context: $context
    referrer: $referrer
    enableTripAttach: $enableTripAttach
    campaignParameters: {
      campaignId: $campaignId
      contentPagination:{
        pageSize: $pageSize
        pageNumber: $pageNumber
      }
    }
    displayPropertyCount: $displayPropertyCount
    includeDeals: true
  ) {
    campaigns {
      id
      headline
      fromOriginHeaderText
      termsAndConditions
      campaignContentPaginationInfo {
        hasMoreContentPages
      }
      description {
        short
        long
      }
      productTypes
      recommendedType
      offers {
        __typename
        name
        image {
          description
          url
        }
        description
        secondaryContent
        ... on DestinationOfferItem {
          affinities
          propertyCount
          lodgingOffer {
            price {
              value
              qualifierText
              disclaimerText
            }
            actionLink {
              href
              text
            }
          }
          flightOffer {
            price {
              value
              qualifierText
              disclaimerText
              prefixText
            }
            actionLink {
              href
              text
            }
          }
          packageOffer {
            price {
              value
              qualifierText
              disclaimerText
              prefixText
              checkPriceText
            }
            strikeThroughPrice {
              value
            }
            actionLink {
              href
              text
            }
          }
          dates
        }
        ... on HotelOfferItem {
          location
          starRating
          guestReviewRating
          guestReviewRatingQualifierText
          guestReviewCount
          vipMessage
          freeCancellationMessage
          badge {
            text
            type
          }
          discountBadge {
            text
            type
          }
          lodgingOffer {
            price {
              value
              qualifierText
              disclaimerText
              allyText
            }
            strikeThroughPrice {
              value
            }
            actionLink {
              href
              text
            }
          }
          dates
        }
        ... on FlightOfferItem {
          airlineName
          airlineImage {
            description
            url
          }
          originCity
          originAirportCode
          destinationCity
          destinationAirportCode
          tripType
          flightClass
          flightOffer {
            price {
              value
              qualifierText
              prefixText
            }
            actionLink {
              href
              text
            }
          }
          dates
        }

        ... on PackageOfferItem {
          flightOfferItem {
            airlineName
            airlineImage {
              description
              url
            }
            originCity
            originAirportCode
            destinationCity
            destinationAirportCode
          }
          hotelOfferItem {
            name
            location
            vipMessage
          }
          packageOffer {
            price {
              value
              qualifierText
              prefixText
              checkPriceText
            }
            actionLink {
              href
              text
            }
          }
          dates
        }
      }
    }
    responseId
    paginationInfo {
      referrer
    }
  }
}

    `;

export const campaignRecommendationsWithOffersQueryQuery = templateJoin`
        query CampaignRecommendationsWithOffersQuery(
  $numCampaigns: Int!
  $pageNumberOfCampaigns: Int!
  $maxNumberOfCampaigns: Int
  $productType: [CampaignProductType!]
  $recommendationType: [RecommendedType]
  $context: ContextInput!
  $userLocation: UserLocationInput
  $referrer: String
) {
  campaignRecommendations(
    numberOfCampaigns: $numCampaigns
    pageNumber: $pageNumberOfCampaigns
    maxNumberOfCampaigns: $maxNumberOfCampaigns
    productType: $productType
    recommendationType: $recommendationType
    userLocation: $userLocation
    context: $context
    referrer: $referrer
    includeDeals: true
  ) {
    campaigns {
      id
      headline
      fromOriginHeaderText
      termsAndConditions
      description {
        short
        long
      }
      productTypes
      recommendedType
      offers {
        __typename
        name
        image {
          description
          url
        }
        description
        secondaryContent
        ... on DestinationOfferItem {
          affinities
          lodgingOffer {
            price {
              value
              qualifierText
              disclaimerText
              prefixText
              checkPriceText
            }
            actionLink {
              href
              text
            }
          }
          flightOffer {
            price {
              value
              qualifierText
              disclaimerText
              prefixText
              checkPriceText
            }
            actionLink {
              href
              text
            }
          }
          packageOffer {
            price {
              value
              qualifierText
              disclaimerText
              prefixText
              checkPriceText
            }
            strikeThroughPrice {
              value
            }
            actionLink {
              href
              text
            }
          }
          dates
        }
        ... on HotelOfferItem {
          location
          starRating
          guestReviewRating
          guestReviewRatingQualifierText
          guestReviewCount
          vipMessage
          freeCancellationMessage
          badge {
            text
            type
          }
          discountBadge {
            text
            type
          }
          lodgingOffer {
            price {
              value
              qualifierText
              disclaimerText
              allyText
            }
            strikeThroughPrice {
              value
            }
            actionLink {
              href
              text
            }
          }
          dates
        }
        ... on FlightOfferItem {
          airlineName
          airlineImage {
            description
            url
          }
          originCity
          originAirportCode
          destinationCity
          destinationAirportCode
          tripType
          flightClass
          flightOffer {
            price {
              value
              qualifierText
              prefixText
            }
            actionLink {
              href
              text
            }
          }
          dates
        }

        ... on PackageOfferItem {
          flightOfferItem {
            airlineName
            airlineImage {
              description
              url
            }
            originCity
            originAirportCode
            destinationCity
            destinationAirportCode
          }
          hotelOfferItem {
            name
            location
            vipMessage
          }
          packageOffer {
            price {
              value
              qualifierText
              prefixText
              checkPriceText
            }
            actionLink {
              href
              text
            }
          }
          dates
        }
      }
    }
    responseId
    paginationInfo {
      referrer
    }
  }
}

    `;

export const customerPropertySearchByIdQueryQuery = templateJoin`
        query CustomerPropertySearchByIdQuery(
  $context: ContextInput!
  $dateRange: PropertyDateRangeInput
  $hotelIds: [String!]
) {
  propertySearch(
    context: $context
    destination: { propertyIds: $hotelIds }
    dateRange: $dateRange
  ) {
    properties {
      name
      id
      infositeURL
      price {
        options {
          displayPrice {
            formatted
            amount
            currencyInfo {
              symbol
              code
              name
            }
          }
        }
      }
      image {
        url
      }
    }
    searchCriteria {
      dateRange {
        checkInDate {
          isoFormat
          day
          month
          year
        }
        checkOutDate {
          isoFormat
          day
          month
          year
        }
      }
    }
  }
}

    `;

export const customerSearchHistoryAllQueryQuery = templateJoin`
        query CustomerSearchHistoryAllQuery($context:ContextInput!,$lobs:[HistoryType!],$numberOfResults:Int){
  customer(context:$context){
    searchHistory(types:$lobs,numberOfResults:$numberOfResults){
		    type
      items {
        id
        localizedDateRange
        localizedAsOfDateTime
        lastViewedDate {
          day
          hour
          minute
          second
          month
          year
        }
        startDate {
          raw
          year
          month
          day
        }
        endDate {
          raw
          year
          month
          day
        }
        originalSearchPrice {
          currencyInfo {
            code
            name
            symbol
          }
          amount
          formatted
        }
        productInfo {
          ... on HistoryActivitySearch {
            regionDetail {
              name
            }
            searchUrl
          }
          ... on HistoryActivityDetail {
            name
            duration
            leadTicketType
            imageUrl {
              description
              url
            }
            searchUrl
          }
          ... on HistoryFlightSearch {
            localizedFlightName
            searchUrl
            routeType
            flightPassengers {
              adults
              agesOfChildren
            }
          }
          ... on HistoryFlightDetail {
            localizedFlightName
            searchUrl
            routeType
            flightPassengers {
              adults
              agesOfChildren
            }
          }
          ... on HistoryPackageSearch {
            localizedPackageName
            localizedRegionName
            localizedPackagesTemplate
            searchUrl
          }
          ... on HistoryPropertySearch {
            regionDetail {
              name
            }
            localizedRoomsTemplate
            searchUrl
          }
          ... on HistoryPropertyDetail {
            regionId
            summary {
              id
              name
            }
            regionDetail {
              name
            }
            reviewInfo {
              summary {
                averageOverallRating {
                  formatted
                }
                totalCount {
                  formatted
                }
              }
            }
            formattedRating
            formattedReviewCount
            propertyId
            gallery {
              featured {
                description
                url
              }
            }
            searchUrl
          }
        }
      }
  }
  }
}
    `;

export const customerSearchHistoryQueryQuery = templateJoin`
        query CustomerSearchHistoryQuery($context: ContextInput!, $lobs: [HistoryType!], $numberOfResults: Int) {
  customer(context: $context) {
    searchHistory(types: $lobs, numberOfResults: $numberOfResults) {
      type
      items {
        startDate {
          raw
          year
          month
          day
        }
        endDate {
          raw
          year
          month
          day
        }
        originalSearchPrice {
          currencyInfo {
            code
            name
            symbol
          }
          amount
          formatted
        }
        productInfo {
          ... on HistoryPropertyDetail {
            regionId
            summary {
              id
              name
            }
            propertyId
            gallery {
              featured {
                url
              }
            }
          }
        }
      }
    }
  }
}

    `;

export const dxPropertySearchQueryQuery = templateJoin`
        query DxPropertySearchQuery($context: ContextInput!, $hotelIds: [String!]!) {
    propertySearch(context:$context, destination:{
        propertyIds:$hotelIds
    },
        sort: REVIEW) {
        properties {
            id
            name
            infositeURL
            price {
                lead {
                    formatted
                    amount
                }
            }
            reviews {
                score
                total
            }
            gallery {
                url
                description
            }
        }
    }
}
    `;

export const mapPropertySearchByIdQuery = templateJoin`
        
query MapPropertySearchById(
$context: ContextInput!,
$rooms: [RoomInput!],
$dateRange: PropertyDateRangeInput,
$propertyIds: [String!],
$filters: PropertySearchFiltersInput
) {
    propertySearch(
        context: $context,
        destination: {
            propertyIds: $propertyIds
        }
        dateRange: $dateRange,
        rooms: $rooms,
        filters: $filters
    ) {
        sortAndFilter {
            options {
                sortAndFilter {
                    name
                    options {
                        label
                        value
                        range {
                            min
                            max
                        }
                        enumValue
                    }
                }
            }
        }
        properties {
            name
            id
            infositeURL
            price {
                lead {
                    formatted
                    amount
                    currencyInfo {
                      symbol
                      code
                      name
                    }
                }
            }
            reviews {
                score
                total
                localizedSubtitle
            }
            star
            image {
                url
            }
            mapMarker {
                latLong {
                    latitude
                    longitude
                }
            }
        }
    }
}

    `;

export const mapPropertySearchByLatLongQuery = templateJoin`
        # GraphQL query to retrieve properties based on lat-long coordinates primarily. User can add filters like dates, rooms and
query MapPropertySearchByLatLong(
    $context: ContextInput!,
    $rooms: [RoomInput!],
    $dateRange: PropertyDateRangeInput,
    $latitude: Float!,
    $longitude: Float!,
    $filters: PropertySearchFiltersInput
    $size: Int
) {
    propertySearch(context: $context, destination: {coordinates: {latitude: $latitude, longitude: $longitude}}, rooms: $rooms, dateRange: $dateRange, sort: DISTANCE, filters: $filters, searchPagination: {size: $size}) {
        properties {
            name
            id
            infositeURL
            price {
                lead {
                    formatted
                    amount
                }
            }
            reviews {
                score
                total
                localizedSubtitle
            }
            star
            image {
                url
            }
            mapMarker {
                latLong {
                    latitude
                    longitude
                }
            }
        }
        summary {
            messages {
                type
                title {
                    text
                }
                subtitle {
                    text
                }
            }
        }
    }
}



    `;

export const propertyFiltersQueryQuery = templateJoin`
        query PropertyFiltersQuery($context: ContextInput!, $regionId: String!) {
  propertySearch(context: $context, destination: { regionId: $regionId }) {
    sortAndFilter {
      options {
        sortAndFilter {
          label
          name
          options {
            label
            optionValue
            filterCategory
            description
            selectedLabel
          }
        }
      }
    }
  }
}

    `;

export const queryPropertyHeroImageQuery = templateJoin`
        query QueryPropertyHeroImage($context: ContextInput!, $propertyId: String!) {
  propertyInfo(context:$context, propertyId:$propertyId) {
    gallery {
      featured {
        description
        url
      }
    }
  }
}

    `;

export const queryPropertyReviewsHeadlineQuery = templateJoin`
        query QueryPropertyReviewsHeadline($context: ContextInput!, $propertyId: String!) {
  propertyInfo(context:$context, propertyId:$propertyId) {
    infositeUrl
    summary {
      id
      name
      overview {
        starRating
      }
      location {
        address {
          city
          countryCode
          firstAddressLine
          secondAddressLine
          postalCode
          province
        }
      }
    }
  }
}

    `;

export const propertySearchQueryQuery = templateJoin`
        query PropertySearchQuery($context: ContextInput!, $hotelIds: [String!]!) {
  propertySearch(context:$context, destination:{
    propertyIds:$hotelIds
  }) {
    properties {
      id
      name
      gallery {
      	url
        description
      }
    }
  }
}

    `;
